const o = {
  // Header / menu
  headerChatNow: "webapp-header-chat-now",
  // Footer
  footerAsk: "webapp-footer-ask",
  footerRequestLawyer: "webapp-footer-request-lawyer",
  // Home page — hero input ("Tell us what's happening")
  homeHero: "webapp-home-hero",
  // Home page — CTA band ("Navigate your legal moment")
  homeCtaNavigate: "webapp-home-cta-navigate",
  // Home page — situation cards, the catch-all "Other" card
  homeSituationOther: "webapp-home-situation-other"
}, t = (e) => `webapp-home-situation-${e.toLowerCase()}`;
export {
  o as CHAT_REF,
  t as homeSituationRef
};
